import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import theme from 'theme';
import { AuthProvider } from 'auth';
import { FirebaseProvider } from 'utils/firebase';
import { MaintenanceGate } from './maintenance/MaintenanceGate/MaintenanceGate';
import { firebaseConfig } from './config';
import { AppRoutes } from './routes';
import './App.css';

const App = () => (
  <FirebaseProvider
    firebaseConfig={firebaseConfig}
    firebaseAppName="oversight"
    firestoreDbId={import.meta.env.VITE_FIREBASE_DB_ID || '(default)'}
  >
    <MaintenanceGate>
      <AuthProvider>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <SnackbarProvider autoHideDuration={3000} maxSnack={3}>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </SnackbarProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </AuthProvider>
    </MaintenanceGate>
  </FirebaseProvider>
);

export default App;
